<template>
  <el-card v-loading="loading" shadow="never">
    <el-form
      :model="form"
      :rules="rules"
      ref="form"
      label-width="100px"
      @keydown.enter.native="onSubmit"
    >
      <el-form-item
        prop="widgetId"
        label="按钮Key"
      >
        <el-input type="text" v-model="form.widgetId" placeholder="同一页面的按钮名称不能重复"></el-input>
      </el-form-item>

      <el-form-item
        prop="description"
        label="按钮名称"
      >
        <el-input type="text" v-model="form.description" placeholder="建议填写按钮上的文字"></el-input>
      </el-form-item>

      <!-- <el-form-item
        prop="widgetType"
        label="按钮类型"
      >
        <el-radio v-model="form.widgetType" label="1">普通按钮</el-radio>
        <el-radio v-model="form.widgetType" label="2">不可隐藏按钮</el-radio>
      </el-form-item> -->

      <el-form-item
        prop="seqNum"
        label="排序号"
      >
        <el-input type="text" v-model="form.seqNum" placeholder="请输入按钮排序号(从大到小)"></el-input>
      </el-form-item>

      <el-form-item>
        <el-button :loading="submitting" type="primary" @click="onSubmit">保存</el-button>
      </el-form-item>
    </el-form>
  </el-card>
</template>

<script>
import {system} from '../../api'

export default {
  name: 'ButtonEdit',

  props: {
    menuCode: String,
    buttonId: String
  },

  mounted () {
    if (this.buttonId) this.getButtonDetail()
  },

  data () {
    return {
      form: {
        description: '',
        widgetId: '',
        seqNum: '',
        // 1 普通 2 不可隐藏
        widgetType: '1'
      },
      menuCodeForEdit: '',
      loading: false,
      submitting: false,
      rules: {
        widgetId: [
          {required: true, message: '请输入按钮名称', trigger: 'blur'},
          {type: 'string', pattern: /^[a-zA-Z0-9_]+$/, message: '只能输入字母数字_，请更正', trigger: 'blur'}
        ],
        seqNum: [
          {type: 'string', pattern: /^-?[0-9]+$/, message: '请输入一个整数', trigger: 'blur'}
        ]
      }
    }
  },

  computed: {
    isAdd () {
      return !this.buttonId
    }
  },

  methods: {
    async getButtonDetail () {
      this.loading = true
      let {data = {}} = await system.getButton(this.buttonId)
      this.loading = false
      let {description, widgetId, seqNum, widgetType, menuCode} = data
      this.menuCodeForEdit = menuCode
      Object.assign(this.form, {
        description, widgetId: widgetId.split('-')[1], seqNum: String(seqNum || ''), widgetType
      })
    },
    async onSubmit () {
      if (this.submitting) return
      let valid = await this.$refs.form.validate()
      if (!valid) return
      if (this.isAdd) {
        this.submitting = true
        let {code, msg} = await system.addButton({...this.form, menuCode: this.menuCode, widgetId: `${this.menuCode}-${this.form.widgetId}`})
        this.submitting = false
        if (code === 0) {
          this.$message({
            type: 'success',
            message: '按钮添加成功'
          })
          this.$bus.$emit('ButtonManagement:refreshTable')
          this.$closeCurrentView()
        } else {
          this.$message({
            type: 'error',
            message: msg
          })
        }
      } else {
        this.submitting = true
        let {code, msg} = await system.updateButton({...this.form, buttonId: this.buttonId, widgetId: `${this.menuCodeForEdit}-${this.form.widgetId}`})
        this.submitting = false
        if (code === 0) {
          this.$message({
            type: 'success',
            message: '按钮更新成功'
          })
          this.$bus.$emit('ButtonManagement:refreshTable')
          this.$closeCurrentView()
        } else {
          this.$message({
            type: 'error',
            message: msg
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.el-card /deep/ .el-card__body {
  padding-top: 30px;
}
</style>
